import { render, staticRenderFns } from "./authenticate_outh2.vue?vue&type=template&id=66ecb624&scoped=true"
import script from "./authenticate_outh2.js?vue&type=script&lang=js&external"
export * from "./authenticate_outh2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ecb624",
  null
  
)

export default component.exports